import { Component, EventEmitter, Inject, Input, LOCALE_ID, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BonusInfo } from 'src/app/services/payment/bonus/bonus.models';
import { DESKTOP_REGULAR, DialogConfig, FULL_DIALOG_CONFIG } from 'src/app/components/dialog/dialog.config';
import { TermsDialogComponent } from '../terms-dialog/terms-dialog.component';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { PaymentMethod } from 'src/app/services/payment/methods/methods.models';
import { TeaserTopMobileComponent } from 'src/app/components/teaser-top-mobile/teaser-top-mobile.component';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { Apollo } from 'apollo-angular';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { Router } from '@angular/router';
import { boostedOfferTrx, gameInfoTrx, infoTrx } from 'src/app/router-translation.labels';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { ChargebackService } from 'src/app/services/profile/chargeback.service';
import { BonusLotteryService } from 'src/app/services/profile/bonuslottery.service';
import { LICENCE } from 'src/app/global.tokens';

type BonusInfoWIthPaymentExclusion = BonusInfo & { notForSelectedPayment?: boolean };
@Component({
  selector: 'app-bonus-selector-dialog',
  templateUrl: './bonus-selector-dialog.component.html',
  styleUrls: ['./bonus-selector-dialog.component.scss']
})
export class BonusSelectorDialogComponent extends TeaserTopMobileComponent {

  constructor(
    public termsDialog: MatDialog,
    private detectDesktopService: DetectDeviceService,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(LICENCE) public licence: string,
    protected apollo: Apollo,
    protected router: Router,
    protected translationConfig: TranslationConfig,
    protected loginStatusService: LoginStatusService,
    protected licenceService: LicenceService,
    protected chargebackService: ChargebackService,
    protected bonusLotteryService: BonusLotteryService,

  ) {
    super(
      loginStatusService,
      locale,
      licence,
      apollo,
      router,
      translationConfig,
      chargebackService,
      bonusLotteryService,
      licenceService
    )
  }

  public redirectUrl: string = null;
  dialogSize: DialogConfig = FULL_DIALOG_CONFIG;
  @Input() selectedBonusInfo: BonusInfo;
  @Input() bonusList: BonusInfo[];
  @Input() selectedPaymentMethod: PaymentMethod
  filteredBonuses: BonusInfoWIthPaymentExclusion[];;
  @Output() selectedBonus = new EventEmitter<BonusInfo>();

  pageTitle = $localize`:@@bonus-select:select bonus`

  boostedUrl = ["", this.translationConfig.getTranslation(infoTrx), this.translationConfig.getTranslation(boostedOfferTrx)];

  ngOnInit(): void {
    this.isDesktop = this.detectDesktopService.isDesktop();
    this.getData();
    if (this.detectDesktopService.isDesktop()) {
      this.dialogSize = DESKTOP_REGULAR
    }
    if (!this.selectedBonusInfo) {
      this.selectedBonusInfo = this.bonusList[0];
    }
    this.filteredBonuses = (this.bonusList as any).map(item => {
      if (item.includedOperators?.length > 0 && !item.includedOperators.includes(this.selectedPaymentMethod.id)) {
        item.notForSelectedPayment = true;
      }
      else {
        item.notForSelectedPayment = item.excludedOperators?.includes(this.selectedPaymentMethod.id) || false;
      }
      return item
    })
  }

  selectBonus(bonus: BonusInfoWIthPaymentExclusion) {
    this.selectedBonusInfo = bonus;
    this.selectedBonus.emit(bonus);
  }

  openTermsDialog(bonus: BonusInfo, isDeposit?: Boolean): void {
    const dialogRef = this.termsDialog.open(TermsDialogComponent, {
      ...this.dialogSize,
      panelClass: this.detectDesktopService.isDesktop() ? "custom-dialog-container-desktop" : 'custom-dialog-container"',
      data:{
        pageName: bonus.pagesNew[0]?.name,
        isFromDeposit: isDeposit
      }
    });


  }
  openAdditionalBoostBonusTerms() {
    const dialogRef = this.termsDialog.open(TermsDialogComponent, {
      ...this.dialogSize,
      panelClass: this.detectDesktopService.isDesktop() ? "custom-dialog-container-desktop" : 'custom-dialog-container"',
      data: boostedOfferTrx
    });
  }
}
